import { Link } from 'react-router-dom';

export default function Terms() {
  return (
    <main className="mx-auto max-w-3xl px-4 py-10 text-sm leading-relaxed text-foreground">
      <Link to="/" className="text-xs uppercase tracking-wide opacity-60 hover:opacity-100">
        ← Home
      </Link>
      <h1 className="mt-6 text-3xl font-semibold">Terms of Service</h1>
      <p className="mt-2 text-xs opacity-60">Last updated: 5 May 2026</p>

      <section className="mt-8 space-y-3">
        <h2 className="text-lg font-semibold">1. The agreement</h2>
        <p>
          These terms govern your use of Nako Pula at{' '}
          <a className="underline" href="https://nakotech.africa">nakotech.africa</a>. By signing
          up you accept these terms and the <Link to="/privacy" className="underline">Privacy Policy</Link>.
        </p>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">2. Hosting region — your consent</h2>
        <p>
          You acknowledge and consent to your data being stored and processed by Supabase Inc. in
          the European Union (Ireland), under EU GDPR safeguards, in line with section 48 of the
          Botswana Data Protection Act 2018.
        </p>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">3. Quality assurance &amp; marketing consent</h2>
        <p>
          You agree that Nako Tech administrators may, for legitimate business purposes,
          access your account data — including journal entries, receipts, uploaded images and
          financial summaries — to perform quality assurance, troubleshoot issues, improve our
          product and AI models, and develop marketing materials (case studies, testimonials,
          benchmarks). Identifiable marketing use can be opted out of at any time by emailing{' '}
          <a className="underline" href="mailto:privacy@nakotech.africa">privacy@nakotech.africa</a>.
          Quality-assurance access is intrinsic to the service and continues regardless.
        </p>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">4. Your responsibilities</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Keep your password confidential.</li>
          <li>Enter accurate accounting data — Nako Pula is a tool, not a substitute for a registered accountant.</li>
          <li>File BURS returns yourself or via your accountant; the figures Nako Pula computes are advisory.</li>
          <li>Do not upload data you do not have the right to process (e.g. third-party customer lists).</li>
        </ul>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">5. Service tiers and pricing</h2>
        <p>
          Free, Smart, Pro and Enterprise tiers each carry their own feature set and price. Tier
          changes apply from the next billing cycle. Refunds are at our discretion.
        </p>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">6. Limitation of liability</h2>
        <p>
          To the extent permitted by Botswana law, Nako Tech's total liability arising from your
          use of Nako Pula is capped at the fees you paid in the 12 months preceding the claim.
          We are not liable for tax penalties, audit findings or business losses arising from
          your use of the service.
        </p>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">7. Termination</h2>
        <p>
          You may close your account at any time from <strong>/app/settings</strong>. We may
          suspend accounts that breach these terms, are inactive for 12+ months, or fail
          payment.
        </p>
      </section>

      <section className="mt-6 space-y-3">
        <h2 className="text-lg font-semibold">8. Governing law</h2>
        <p>These terms are governed by the laws of the Republic of Botswana.</p>
      </section>

      <p className="mt-10 text-xs opacity-60">
        See also the <Link to="/privacy" className="underline">Privacy Policy</Link>.
      </p>
    </main>
  );
}
